import { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import styles from './Winners.module.css';
import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';

import logoVideo from '../../assets/video/logoVideo.webm';
import snow from '../../assets/video/snow1.webm';
import confetti from '../../assets/video/confetti.webm';

export const Winners = ({ winnerMessages }) => {
  const logoVideoRef = useRef(null);
  const confettiRef = useRef(null);

  const snowDuration = 1; // длительность перебивки со снежинкой

  useEffect(() => {
    let idTimeout = '';
    if (logoVideoRef.current) {
      idTimeout = setTimeout(() => {
        logoVideoRef.current.play().catch((error) => {});
      }, snowDuration * 1000);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [logoVideoRef]);

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current) {
      idTimeout = setTimeout(() => {
        confettiRef.current.play().catch((error) => {});
      }, 5000);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [confettiRef]);

  const errorHandler = (e, channel) => {
    e.target.src = iconsSources[channel];
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.topBlock}>
        <div className={styles.logoBlock}>
          <video muted="muted" playsInline ref={logoVideoRef}>
            <source src={logoVideo} type="video/webm"></source>
          </video>
        </div>
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1.1, 1], rotate: [1, 0, -1, 0, 1] }}
          transition={{
            scale: {
              times: [0, 0.85, 1],
              duration: 1.4,
              delay: 0.4 + snowDuration,
            },
            rotate: {
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 1.8 + snowDuration,
            },
          }}
          className={styles.wordWinners}
        >
          победители!
        </motion.div>
      </div>
      {winnerMessages && (
        <div className={styles.winnersWrapper}>
          {winnerMessages.slice(0, 3).map((win, i) => {
            const { message } = win;

            const imgSrc =
              (message.image !== '1' && message.image) ||
              iconsSources[message.channel];

            return (
              <motion.div key={message.id + i} className={styles.winnerItem}>
                <div className={styles.avatarBlock}>
                  <motion.img
                    initial={{ clipPath: 'circle(0% at 50% 50%)' }}
                    animate={{
                      clipPath: [
                        'circle(0% at 50% 50%)',
                        'circle(50% at 50% 50%)',
                        'circle(45% at 50% 50%)',
                      ],
                    }}
                    transition={{
                      duration: 1,
                      delay: i * 0.8 + 2 + snowDuration,
                      times: [0, 0.6, 1],
                      ease: 'easeOut',
                    }}
                    className={styles.avatar}
                    src={imgSrc}
                    onError={(e) => errorHandler(e, message.channel)}
                    alt="avatar"
                  />
                  <motion.svg
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{
                      duration: 0.55,
                      delay: i * 0.7 + 1.8 + snowDuration,
                    }}
                    width="100%"
                    height="100%"
                    viewBox="0 0 200 200"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <defs>
                      <linearGradient
                        id="strokeGradient"
                        x1="0%"
                        y1="100%"
                        x2="100%"
                        y2="0%"
                      >
                        <stop offset="10%" stopColor="#031BFE" />
                        <stop offset="54%" stopColor="#85F1F8" />
                        <stop offset="90%" stopColor="#0197FE" />
                      </linearGradient>
                    </defs>

                    <circle
                      cx="100"
                      cy="100"
                      r="90"
                      fill="none"
                      stroke="url(#strokeGradient)"
                      strokeWidth="7"
                    />
                  </motion.svg>
                </div>
                <motion.div
                  className={styles.author}
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, delay: 2 + snowDuration }}
                >
                  {message.author || hideNumber(message.senderNumber)}
                </motion.div>
              </motion.div>
            );
          })}
        </div>
      )}

      <video
        ref={confettiRef}
        muted="muted"
        loop
        playsInline
        className={styles.transIn}
      >
        <source src={confetti} type="video/webm"></source>
      </video>

      <video
        autoPlay="autoplay"
        muted="muted"
        playsInline
        className={styles.transIn}
      >
        <source src={snow} type="video/webm"></source>
      </video>
    </div>
  );
};
